import type { Currency } from './currency';

export enum EProductType {
  DIGITAL = 1,
  SERVICE = 2,
  PHYSICAL = 3,
  TICKET = 4,
  ALUMY = 36,
  SUBSCRIPTION = 99
}

export enum EModerationStatus {
  WITHOUT_STATUS = 'N',
  PENDING = 'P',
  DISAPPROVED = 'R',
  APPROVED = 'A',
  MODERATION = 'M',
  DEFAULT = 'Não definido'
}

export interface IProduct {
  readonly id: number;
  readonly title: string;
  readonly description: string;
  readonly image_id: number;
  readonly image: string;
  readonly expiration_date: string;
  readonly has_expiration_date: boolean;
  readonly sales_recovery: boolean;
  readonly allows_boleto: boolean;
  readonly allows_paypal: boolean;
  readonly allows_card: boolean;
  readonly allows_multiple_cards: boolean;
  readonly comission_type: string;
  readonly comission_value: number;
  readonly recurring_comission_type: string;
  readonly recurring_comission_value: number;
  readonly membership_comission_type: string;
  readonly membership_comission_value: number;
  readonly comission_on_first_invoice: boolean;
  readonly charge_type: string;
  readonly currency_id: number;
  readonly price: number;
  readonly recurring_value: number;
  readonly recurring_frequency_type: string;
  readonly recurring_frequency: number;
  readonly undetermined_charges: boolean;
  readonly limit_charges: number;
  readonly overdue_limit: number;
  readonly permanent_access: boolean;
  readonly membership_fee: boolean;
  readonly membership_price: number;
  readonly trial: boolean;
  readonly trial_days: number;
  readonly visible: boolean;
  readonly auto_affiliation: boolean;
  readonly infinity_funnel: boolean;
  readonly recruit: boolean;
  readonly recruit_commission_type: string;
  readonly recruit_commission_value: number;
  readonly recruit_max_sales: number;
  readonly funnel_commission: number;
  readonly affiliate_instructions: string;
  readonly affiliation_contract: string;
  readonly type: number;
  readonly author_name: string;
  readonly alternative_url: string;
  readonly refund_days: number;
  readonly prelaunch: boolean;
  readonly launch_date: string;
  readonly sales_expectation: number;
  readonly program_content: string;
  readonly support_email: string;
  readonly categories: any[];
  readonly url_thankyou_card: string;
  readonly url_thankyou_boleto: string;
  readonly friendly_name: string;
  readonly recovery_email: string;
  readonly has_children: boolean;
  readonly thankyou_type: number;
  readonly webhook_type: string;
  readonly webhook: boolean;
  readonly webhook_url: string;
  readonly parent_product: number;
  readonly parent_id: number;
  readonly name_extract_description: string;
  readonly unlimited_installment: boolean;
  readonly deliver_first_charge: boolean;
  readonly coproducers: Array<any>;
  readonly deliveries: Array<any>;
  readonly physicalDelivery: any;
  readonly hash: string;
  readonly stock: number;
  readonly notify_stock: number;
  readonly recurring_start_charging: string;
  readonly recurring_days_start_charging: number;
  readonly document_on_checkout: boolean;
  readonly email_welcome: boolean;
  readonly ask_address_checkout: boolean;
  readonly ask_address_thanks: boolean;
  readonly hide_quantity: boolean;
  readonly url_checkout: string;
  readonly is_producer: boolean;
  readonly moderation_status: string;
  readonly default_sales_page: string;
  readonly yearly_installment: boolean;
  readonly producer_id: number;
  readonly remove_access: boolean;
  readonly send_billing_reminder: boolean;
}

export interface IBasic {
  id: number;
  title: string;
  type: EProductType;
  categories: number[];
  description: string;
  image: any;
}

export interface IProductSales {
  id: number;
  title: string;
  checked?: boolean; //usado apenas para controle do front
  children: Array<{ id: number; title: string; checked?: boolean }>;
}

export enum EChargeType {
  SINGLE = 'N',
  SUBSCRIPTION = 'A',
  OTHER = 'L',
  FREE = 'G'
}

export enum EComissionType {
  VALUE = 'V',
  PERCENTAGE = 'P'
}

type ProductPrice = {
  id: number;
  value: number;
  currency: Currency;
  created_at: string;
  updated_at: string;
};

export type ProductOffer = {
  id: number;
  name: string;
  description: string;
  product_id: number;
  key: string;
  is_active: boolean;
  is_public: boolean;
  is_default: boolean;
  is_visible_affiliate: boolean;
  created_at: string;
  updated_at: string;
  prices: ProductPrice[];
};

export type CreateOfferPayload = {
  name: string;
  description?: string;
  prices: Array<{
    value: number;
    currency_code: string;
  }>;
};

export type UpdateOfferPayload = {
  name?: string;
  description?: string;
  prices?: Array<{
    value: number;
    currency_code: string;
  }>;
};

export type GetProductOffersParams = {
  order_by_name_asc?: boolean;
  trashed?: boolean;
};

export type SubscriptionPlan = {
  plan_id: number;
  plan_title: string;
  plan_desc: string;
  plan_frequencia: string;
  plan_value: number;
  plan_trocaplanoproduto: boolean;
  plan_trocaplanovariacao: boolean;
  plan_url_checkout: string;
  plan_is_default: boolean;
  plan_comissao_valor: number;
  plan_reccomissao_valor: number;
  membership_fee: boolean;
};

export type PlanChangeConfig = Array<{
  plan_id: number;
  plan_title: string;
  plan_desc: string;
  product_id: number;
  product_name: string;
  base_price: number;
  selected: boolean;
  variation: boolean;
}>;

export type SetPlanChangeConfigPayload = {
  targetPlanId: number;
  allows_plan_change_for_product: boolean;
  allows_plan_change_for_variation: boolean;
  plan_changeconfig: Array<{
    plan_id: number;
    variation: boolean;
  }>;
};

export interface IContentDelivery {
  download_hash: boolean;
  delivery_nutror: boolean;
}
